import { createStore as reduxCreateStore } from "redux";

import { rootReducer } from "./reducer/reducerAssembler";

const createStore = () => reduxCreateStore(rootReducer);
export default createStore;